import type { RichTextField } from "@prismicio/client"
import { PrismicRichText as BasePrismicRichText } from "@prismicio/react"
import classNames from "classnames"
import React from "react"

import { htmlSerializer } from "./htmlSerializer"
import type { Interpolations } from "@/libs/prismic/helpers"
import { linkResolver } from "@/libs/prismic/helpers"

export type RichTextProps = {
  field: RichTextField
  interpolations?: Interpolations
  className?: string
  id?: string
  disableImgBlueFilter?: boolean
}

export const RichText = ({ field, interpolations, id, className, disableImgBlueFilter = false }: RichTextProps) => {
  const components = htmlSerializer({ interpolations, disableImgBlueFilter })

  return (
    <div className={classNames("w-full max-w-[867px]", className)} id={id}>
      <BasePrismicRichText field={field} linkResolver={linkResolver} components={components} />
    </div>
  )
}
